import  React from 'react'
import { DashboardModel } from '../../../../models/DashboardModel'
import SelftPreparer from './Shared/SelfPreparer'
import Agent from './Shared/Agent'

export interface Props {
  model: DashboardModel
  handleApplicationClick: any
  searchTxt: string
  loading: boolean
}

export default class CurrentYear extends React.Component<Props> {
  constructor(props: Props) {
    super(props)

    this.state = { }
  }

  render() {
    const {
      model, searchTxt, handleApplicationClick, loading,
    } = this.props

    if (loading) return <div>Loading</div>

    if (model?.isConsultant) {
      return <Agent model={model} searchTxt={searchTxt} handleApplicationClick={handleApplicationClick} />
    }
    return (
      <SelftPreparer model={model} searchTxt={searchTxt} handleApplicationClick={handleApplicationClick} />
    )
  }
}
